import {
  FETCH_USER_RECURRING_RECEIVABLES_SUCCESS,
  LOGOUT_USER_SUCCESS,
} from 'constants/index';
import type { RecurringPayment } from 'models';
import {
  CANCEL_RECURRING_RECEIVABLE_SUCCESS,
  RECURRING_RECEIVABLE_CANCELLED_STATUS,
} from '../../../constants';

type RecurringReceivablesAction =
  | {
      type: typeof FETCH_USER_RECURRING_RECEIVABLES_SUCCESS;
      payload: {
        recurringReceivables: RecurringPayment[];
      };
    }
  | {
      type: typeof CANCEL_RECURRING_RECEIVABLE_SUCCESS;
      payload: {
        id: string;
      };
    }
  | { type: typeof LOGOUT_USER_SUCCESS };

export const recurringReceivables = (
  state: RecurringPayment[] = [],
  action: RecurringReceivablesAction,
) => {
  switch (action.type) {
    case FETCH_USER_RECURRING_RECEIVABLES_SUCCESS:
      return action.payload?.recurringReceivables;
    case LOGOUT_USER_SUCCESS:
      return [];
    case CANCEL_RECURRING_RECEIVABLE_SUCCESS:
      const { id } = action.payload;
      const newState = [...state];
      const index = newState.findIndex(
        recurringReceivable => recurringReceivable.id === id,
      );
      const updated = newState.splice(index, 1).shift();
      const { status: _status, ...rest } = updated;

      newState.splice(index, 0, {
        ...rest,
        status: RECURRING_RECEIVABLE_CANCELLED_STATUS,
      });

      return newState;
    default:
      return state;
  }
};
